let clientSignOutInProgress = false;
let signOutTeardownOpsDepth = 0;

/** Blocks new API traffic and query retries during client sign-out teardown. */
export function beginClientSignOut(): void {
  clientSignOutInProgress = true;
}

export function isClientSignOutInProgress(): boolean {
  return clientSignOutInProgress;
}

/**
 * True when member API calls should be rejected (sign-out active, not in the
 * narrow window that allows end-session / activity updates).
 */
export function isSignOutApiBlocked(): boolean {
  return clientSignOutInProgress && signOutTeardownOpsDepth === 0;
}

/**
 * Runs sign-out cleanup requests (end session, activity ping) while the gate
 * is on but API traffic is still allowed.
 */
export async function runSignOutTeardownOps<T>(
  fn: () => Promise<T>,
): Promise<T> {
  signOutTeardownOpsDepth += 1;
  try {
    return await fn();
  } finally {
    signOutTeardownOpsDepth -= 1;
  }
}

/** Tests and dev HMR only. */
export function resetClientSignOutGate(): void {
  clientSignOutInProgress = false;
  signOutTeardownOpsDepth = 0;
}
